import firebase from 'firebase';
const db = firebase.database();
const auth = firebase.auth();

/*export const cargarPolizas = () => {
    return dispatch => {
        dispatch({ "type": "LOADER_SHOW" });
        
        db.ref("polizas/0018500943").once("value", snapshot => {
            let data = snapshot.val();
            let listaPolizas = [];
            
            Object.keys(data).map((item,i) => {
                let ramo = data[item];
                if(item == "autos" && ramo.polizas) {
                    let filtrado = ramo.polizas.filter((item) => {
                        if(item.cveRol === "TOM") {
                            return item;
                        }
                    });
                    listaPolizas = listaPolizas.concat(filtrado);
                }
            });

            dispatch({ "type": "LOADER_HIDE" });
            dispatch({ "type": "AF_LISTA_POLIZAS", "listaPolizas": listaPolizas });
        }, reason => {
            throw reason;
        });
    }
}*/

/*export const cargarFamiliares = () => {
    return dispatch => {
        dispatch({ "type": "LOADER_SHOW" });
        
        //db.ref("acceso-familiar/" + auth.currentUser.uid).on("value", snapshot => {
        db.ref("acceso-familiar/iUYg97GEcQV3g9Ase2IHqLxCAr33").on("value", snapshot => {
            let data = snapshot.val();
            let listaFamiliares = [];
            
            if(data != null)
                Object.keys(data).map((item,i) => {
                    let pendiente = true, polizas = [];
                    data[item].id = item;
                    
                    if(!data[item].polizas){
                        data[item].polizas = polizas; pendiente = false;
                    } else {
                        let dataPolizas = data[item].polizas;
                        
                        Object.keys(dataPolizas).map((item) => {
                            polizas.push(item);
                            if(dataPolizas[item] == false) {
                                pendiente = false;
                            }
                        });
                    }
                    
                    data[item].polizas = polizas;
                    data[item].pendiente = pendiente;
                    listaFamiliares.push(data[item]);
                });

            dispatch({ "type": "LOADER_HIDE" });
            dispatch({ "type": "AF_LISTA_FAMILIARES", "listaFamiliares": listaFamiliares });
        }, reason => {
            throw reason;
        });
    }
}*/


// WEBPACK FOOTER //
// ./src/acceso-familiar/flujo.act.js